import { world } from '../../languages';
import schedule from '../../utils/sale/schedule';
import { DEFAULT_CONFIG, SALE_CONFIG } from './marketing-bar.constants';

export const isSale = () => schedule.saleDays || schedule.saleLastDay;

export const getMarketingBarData = () => {
    if (isSale()) {
        return SALE_CONFIG[world];
    }

    return DEFAULT_CONFIG[world];
};
